import React, {Component} from "react";
import PropTypes from "prop-types";
import chunk from "lodash/chunk";
import debounce from "lodash/debounce";
import find from "lodash/find";
import escapeRegExp from "lodash/escapeRegExp";
import {isUnfree} from "./license";

import View from "./view";

const DEBOUNCE = 50;
const PER_PAGE = 15;
const WHITESPACES = / +/;
const STARTS_AND_ENDS_WITH_START_AND_ENDS = /^\^.*\$$/;

/**
 * Finds packages matching search terms and returns a subset as an array.
 */
const refilter = (search, packages, {withUnfree = false} = {}) => {
	let attrs = Object.keys(packages);
	let words = search.toLowerCase().split(WHITESPACES).filter(Boolean);

	// Short-circuits regexp like ^$
	// Otherwise, the word breaking algorithm beforehand might play
	// tricks on unsuspecting regexers.
	if (search.match(STARTS_AND_ENDS_WITH_START_AND_ENDS)) {
		words = [search];
	}

	// Converts to regexes, when possible.
	words = words.map((word) => {
		try       { return new RegExp(word); }
		catch (e) { return new RegExp(escapeRegExp(word)); }
	})

	attrs = attrs.filter(function (attr) {
		var info = packages[attr];
		var description = info["meta"]["description"] || "";
		var longDescription = info["meta"]["longDescription"] || "";

		function match(word) {
			return find([
				attr.toLowerCase(),
				info["name"].toLowerCase(),
				description.toLowerCase(),
				longDescription.toLowerCase(),
			], (value) => value.match(word))
		};

		let kept = true;
		kept = kept && words.every(match);
		if (!withUnfree) {
			kept = kept && !isUnfree(info["meta"]["license"]);
		}

		return kept;
	});

	const results = attrs.sort(function(a, b) {
		var ia = packages[a]["name"].toLowerCase();
		var ib = packages[b]["name"].toLowerCase();
		if (ia < ib) return -1;
		if (ia > ib) return 1;

		if (a === b) {
			return 0;
		}

		return a < b ? -1 : 1;
	});

	return results.map((attr) => packages[attr]);
};

/**
 * Behavior component for the listing.
 */
class FilteredList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			results: [],
			pages: [],
			opened: null,
		};

		this.filter = debounce(this.filter, DEBOUNCE);
	}
	componentWillMount() {
		this.componentWillReceiveProps(this.props);
	}
	componentWillReceiveProps(nextProps) {
		const {search, withUnfree} = nextProps;
		const {packages} = this.context.data;
		this.filter(packages, search, withUnfree);
	}
	filter(packages, search, withUnfree) {
		const {page} = this.props;
		const results = refilter(search, packages, {withUnfree});
		const pages = chunk(results, PER_PAGE);
		this.setState({results, pages});
		if (pages.length < page) {
			this.first();
		}
	}

	first() {
		this.props.onPageChange(1);
	}
	last() {
		this.props.onPageChange(this.state.pages.length);
	}

	handleOpen(attribute) {
		if (this.state.opened === attribute) {
			this.setState({opened: null});
		}
		else {
			this.setState({opened: attribute});
		}
	}

	navigate(offset) {
		const {pages} = this.state;
		let page = this.props.page + offset;
		if (page < 1) { page = 1; }
		if (page > pages.length) { page = this.props.page; }
		this.props.onPageChange(page);
	}

	render() {
		const {results, pages, opened} = this.state;
		const page = this.props.page - 1;
		const {commit} = this.context.data;
		const resultsPage = pages[page] || [];
		const start = (page * PER_PAGE) + 1;
		const end = Math.min((page+1) * PER_PAGE, results.length);

		return <View
			{...{
				commit,
				end,
				opened,
				page,
				pages,
				results,
				resultsPage,
				start,
			}}
			first={() => this.first()}
			handleOpen={(attribute) => this.handleOpen(attribute)}
			last={() => this.last()}
			navigate={(offset) => this.navigate(offset)}
		/>;
	}
}

FilteredList.contextTypes = {
	data: PropTypes.object,
};

export default FilteredList;



// WEBPACK FOOTER //
// ./src/filtered_list.js